import Experience from '../Experience.js'
import EventEmitter from 'events'

import { Room } from './models/index.js'
import Background from '../Background.js'

export default class World extends EventEmitter {
  constructor() {
    super()

    this.experience = new Experience()
    this.scene = this.experience.scene
    this.backgroundScene = this.experience.backgroundScene
    this.resources = this.experience.resources

    // Events
    this.resources.on('ready', () => {
      // Add here some objects (before new Environment())
      // ...
      this.background = new Background()
      this.room = new Room()

      // this.environment = new Environment()

      this.emit('worldready')
    })
  }

  update() {
    if (this.room) this.room.update()
  }

  switchViewport(device) {
    if (this.room) this.room.switchViewport(device)
  }
}
